import { http } from '@/utils/http.js';
import { teamPath } from '@/utils/paths.js';

export const ApplicationKeyApi = {
  show(id) {
    return http.get(`${teamPath()}/applications/${id}/key`).then((response) => response.data.secret);
  },

  store(id) {
    return http.post(`${teamPath()}/applications/${id}/key`).then((response) => response.data.secret);
  },
};
